export const klantenvertellenOptions = {
    props: {
        'klantenvertellen': {
            type: Object,
            required: true
        },
        'klantenvertellenDefault': {
            type: Object,
            required: false
        }
    },

    data() {
        return {
            cookieName: 'active-klantenvertellen-object',
            cookieKlantenvertellen: null
        }
    },

    computed: {
        hasRating() {
            return (!_.isEmpty(this.klantenvertellen) || !_.isEmpty(this.cookieKlantenvertellen));
        },

        hasKlantenvertellenProp() {
            return !_.isEmpty(this.klantenvertellen);
        },

        score() {
            if (!this.hasKlantenvertellenProp) {
                return this.cookieKlantenvertellen.averageScore
            }

            if (this.klantenvertellen?.averageScore) {
                return this.klantenvertellen?.averageScore;
            }

            if (this.klantenvertellenDefault.averageScore) {
                return this.klantenvertellenDefault.averageScore;
            }

            return 9.9;
        },

        stars() {
            if (this.klantenvertellen.stars) {
                return this.klantenvertellen.stars;
            }

            if (this.klantenvertellenDefault.stars) {
                return this.klantenvertellenDefault.stars;
            }

            return 5;
        },

        percentage() {
            return this.stars * 20;
        },

        numberOfReviews() {
            if (!this.hasKlantenvertellenProp) {
                return this.cookieKlantenvertellen.numberOfReviews
            }

            return this.klantenvertellen.numberOfReviews
        },

        viewLink() {
            if (!this.hasKlantenvertellenProp) {
                return this.cookieKlantenvertellen.viewLink
            }

            return this.klantenvertellen.viewLink
        },

        writeLink() {
            if (!this.hasKlantenvertellenProp) {
                return this.cookieKlantenvertellen.writeLink
            }

            return this.klantenvertellen.writeLink
        },

        basedOnText() {
            return window.Drupal.t('Based on @type reviews', {'@type': this.numberOfReviews});
        }
    },

    mounted() {
        if (this.hasKlantenvertellenProp) {
            this.populateCookie();
        }

        if (!this.hasKlantenvertellenProp) {
            this.cookieKlantenvertellen = this.$cookies.get(this.cookieName);
        }
    },

    methods: {
        shouldPopulateCookie() {
            return true;
        },

        populateCookie() {
            if (this.shouldPopulateCookie() === false) {
                return;
            }

            this.$cookies.remove(this.cookieName);
            this.$cookies.set(this.cookieName, JSON.stringify(this.klantenvertellen));
        }
    }
}
